import { render } from "./ButtonsPage.vue?vue&type=template&id=0749d030&ts=true"
import script from "./ButtonsPage.vue?vue&type=script&lang=ts"
export * from "./ButtonsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__